import React, {useEffect, useState} from "react";
import Layout from "../../../components/mobile/Layout/layoutmobileempty";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import HeaderMobile from "../../../components/mobile/header/headerv2";
import {getlistCategory,getlistMucgia,getlistProductV1} from '../../../service/GiamGiaService';
import {responsiveproductlistmobile4}  from "../../../utils/constant";
import {Item} from "../../../components/mobile/product";
import { pushtracking } from "../../../service/trackingService";
import { useLocation } from "@reach/router";


import "./css/giam-gia.css";

const GiamGia=()=> {
    const location = useLocation();
    const InfiniteScroll = ({ loadMore }) => {
        useEffect(() => {
          const handleScroll = () => {
            var check = Math.abs(parseInt(window.innerHeight +document.documentElement.scrollTop) - parseInt(document.documentElement.offsetHeight)) 
            if (check === 0 || check === 1){
                loadMore();
             }
          };
      
          window.addEventListener("scroll", handleScroll);
          return () => {
            window.removeEventListener("scroll", handleScroll);
          };
        }, [loadMore]);
      
        return null;
    };

    const [groupId, setGroupId] = useState('');
    const [cateId, setCateId] = useState('');
    const handleClickGetCateFunctionByCateId=(id)=>{     
        setCateId(id);
        getlistMucGia_(id);
        setLoadMoreStartProduct(0);
        setItemDataProduct([]);
        setGroupId('');
        getDataProduct(0,id,'');
    }

    const handleClickGetMucGiaBygroupId=(id)=>{
        setGroupId(id);
        setLoadMoreStartProduct(0);
        setItemDataProduct([]);
        getDataProduct(0,cateId,id);
    }

    // list cate 
    const [catefunction, setCateFunction] = useState([]);
    const [categoryId, setCategoryId] = useState('');
    const getlistCategory_ =()=>{
        let param = {
            phanloai:  'Giảm giá',
            mucgia: null
        };
        try{
            getlistCategory(param).then((response) => {
                setCategoryId(response.message[0].code);
                if(+response.status === 200  && response.message !== "Không tìm thấy dữ liệu."){
                    setCateFunction(response.message);
                }             
            });
        }catch(e){
            console.log(e);
        }
    }
    // muc gia
    const [MucGiafun, setMucGiaFunc] = useState([]);
    const getlistMucGia_ =(cateId)=>{
        let param = {
            phanloai:  'Giảm giá',
            category: cateId ? cateId: ""
        };
        try{
            getlistMucgia(param).then((response) => {
                if(+response.status === 200  && response.message !== "Không tìm thấy dữ liệu."){
                    setMucGiaFunc(response.message);
                }             
            });
        }catch(e){
            console.log(e);
        }
    }

    // Get Data
    const [itemDataProduct, setItemDataProduct] = useState([]);
    const [totalItemProduct, setTotalItemProduct] = useState(0);
    const [loadMoreStartProduct, setLoadMoreStartProduct] = useState(0);
    const getDataProduct = (start,cate,mucgia) => {
        
        let param = {
            phanloai:  'Giảm giá',
            category: cate ? cate : "",
            item: '',
            mucgia: mucgia ? mucgia : null,
            cuahang: "",
            current_page: start,
            per_page: 10
        };

        try{
            getlistProductV1(param).then((response) => {
                if(response.status == 200 && response.message.length >0  && response.message !== "Không tìm thấy dữ liệu."){
                    console.log(response);
                    setItemDataProduct((prevData) => [...prevData, ...response.message]);
                    setTotalItemProduct(+response.metadata?.total_item);
                    try{
                        var _sku_list = [];
                        response.message.forEach((item)=>{
                            _sku_list.push(item?.sku);
                        });
                        pushtracking(window.localStorage.getItem('sessionId')??null,
                        window.localStorage.getItem('_id')??null,
                        window.localStorage.getItem('phone')??null ,
                        location.pathname, "Danh sách sản phẩm giảm giá", 0,0,'index','inWeb',_sku_list,'Website Mobile').then((response)=>{
                            console.log('send tracking');
                        });
                    }catch(e){console.log(e)}
                }               
              });
        }catch(e){
            console.log(e);
        } 
    };

    const handleLoadMoreProduct = (e) => {
        const newStart = loadMoreStartProduct + 1;
        setLoadMoreStartProduct(newStart);
        getDataProduct(newStart,cateId,groupId);
    }; 
    const time = new Date();
    useEffect(()=>{

        getlistCategory_();
        getlistMucGia_();
        setLoadMoreStartProduct(0);
        getDataProduct(0, '','');

    },[]);

    const resetGetAllData =()=>{
        setCateId('');
        setGroupId('');
        setItemDataProduct([]);
        setLoadMoreStartProduct(0);
        getDataProduct(0, '','');
    }

    return(
        <Layout>
            <HeaderMobile Type={'headerInclude'} showBanner={false} linkBanner="" showText = {true} showSearchIcon= {true} showNoti = {true} showCart = {true} showTitle = {"Giảm giá"} /> 
            <div id="content_giamgia">
                <div className="row header-hotdeal">
                    <div className="bg-hodeal">
                        <img src="/../images/product/bannergiamgia.png" alt="icon"/>
                    </div>
                </div>
                <div className="row list-banner mgt-10">
                    <div className="col-12" id="box_cate_donggia"> 
                        <div className={cateId === '' ? (" col-2 list-menu-detail selected-bgcolor-red"):(" col-2 list-menu-detail") } >
                            <span onClick={resetGetAllData}>Tất cả</span>
                        </div>
                        <div className="col-10">
                            {
                                catefunction?.length>0?(
                                    <Carousel key="categoryChild"
                                        responsive={responsiveproductlistmobile4}
                                    > 
                                    {

                                        catefunction?.map((item, i)=>{
                                            return <div key={i} className={cateId === item.code ? (" col-3 list-menu-detail selected-bgcolor-red"):(" col-3 list-menu-detail bg-white") }
                                            onClick={()=>handleClickGetCateFunctionByCateId(item.code)}>
                                                        <span>{
                                                        item?.name?.length > 15 ? ( (item?.name).substring(0, 15) +'...') :(item?.name)
                                                        }</span>
                                                    </div>
                                        })
                                    }
                                    </Carousel>
                                ):(null)
                            }
                        </div>
                    </div>
                </div>
                <div className="row list-banner mgt-10 box_goup_giamgia">
                    {
                        MucGiafun?.length>0?(
                            <Carousel key="categoryChild"
                                responsive={responsiveproductlistmobile4}
                            >
                            {
                                MucGiafun?.map((item, i)=>{
                                    return <div key={i} className={+groupId === +item.code ? ("list-menu-detail pdx-10 co-price bg-white selected-color-red"):("list-menu-detail pdx-10 co-price bg-white") } onClick={()=>handleClickGetMucGiaBygroupId(item.code)}>
                                                <span>{
                                                item?.name?.length > 10 ? ( (item?.name).substring(0, 10) +'...') :(item?.name)
                                                }</span>
                                            </div>
                                })
                            }
                            </Carousel>
                        ):(null)
                    }
                </div>
                <div className="row pdx-5">
                    <ul className="row col-ul-1">
                        {
                            itemDataProduct.length > 0 ? 
                            (
                                itemDataProduct.map((item, j)=>{
                                return <Item item={item} index={time+item.sku+j}/>
                                })
                            )
                            :
                            (null)
                        }                
                    </ul>
                    <InfiniteScroll loadMore={handleLoadMoreProduct} />
                    {
                        +totalItemProduct - +itemDataProduct.length >0 ?(
                            <div className="loading-page-app-item pdy-5" style={{textAlign:"center"}}> <img src="/../images/loading.gif" alt="icon"/></div> 
                        ):(null)
                    }
                    
                </div>   
            </div> 
        </Layout>
    )
}
export default GiamGia;